import { Modal } from "antd";
export const showConfirm = ({
  title = null,
  content = "",
  okText = "OK",
  cancelText = "Cancel",
  hideCancel = false,
}) => {
  return new Promise((resolve) => {
    Modal.confirm({
      title,
     icon: hideCancel ? null : null,
      centered: true,
      content: typeof content == "string"
        ? <span dangerouslySetInnerHTML={{ __html: content }} />
        : content,
      okText,
      cancelText,
      okCancel: !hideCancel,
      cancelButtonProps: hideCancel ? { style: { display: "none" } } : {},
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};
